import IconBase from "./IconBase";

const QRIcon = props => (
  <IconBase {...props}>
    <g transform="translate(2 2)" fill="none" fillRule="evenodd">
      <rect
        stroke="currentColor"
        strokeWidth="1.5"
        x="0"
        y="0"
        width="5"
        height="5"
        rx="1"
      />
      <rect
        stroke="currentColor"
        strokeWidth="1.5"
        x="0"
        y="11"
        width="5"
        height="5"
        rx="1"
      />
      <rect
        stroke="currentColor"
        strokeWidth="1.5"
        x="11"
        y="0"
        width="5"
        height="5"
        rx="1"
      />
      <rect fill="currentColor" x="1.5" y="1.5" width="2" height="2" rx=".3" />
      <rect fill="currentColor" x="1.5" y="12.5" width="2" height="2" rx=".3" />
      <rect fill="currentColor" x="12.5" y="1.5" width="2" height="2" rx=".3" />
      <rect
        fill="currentColor"
        x="8.5"
        y="8.5"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="11.25"
        y="8.5"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="14"
        y="8.5"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="8.5"
        y="11.25"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="14"
        y="11.25"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="11.25"
        y="14"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="14"
        y="14"
        width="1.25"
        height="1.25"
        rx=".3"
      />
      <rect
        fill="currentColor"
        x="8.5"
        y="14"
        width="1.25"
        height="1.25"
        rx=".3"
      />
    </g>
  </IconBase>
);

export default QRIcon;
